import { getRouteQueryParam, RouteQuery } from './routeQuery';

export type { RouteQuery } from './routeQuery';

export const UTM_QUERY_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

export function buildUpgradeRedirectLink(params: URLSearchParams, routeQuery: RouteQuery): URLSearchParams {
  UTM_QUERY_PARAMS.forEach((param) => {
    const value = getRouteQueryParam(routeQuery, param);

    if (value) {
      params.append(param, value);
    }
  });

  return params;
}
